module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edulist-wrap"
  }, [_c('div', {
    staticClass: "edulist-item",
    class: {
      'edulist-item-last': _vm.eduLength === _vm.index + 1
    }
  }, [_c('p', {
    staticClass: "edulist-time"
  }, [_vm._v(_vm._s(_vm.getTime) + "毕业于")]), _vm._v(" "), _c('p', {
    staticClass: "edulist-name"
  }, [_c('span', [_vm._v(_vm._s(_vm.eduList.school))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.eduList.professional) + "专业")])]), _vm._v(" "), _c('img', {
    staticClass: "edulist-edit-icon",
    attrs: {
      "src": require("../../../../assets/img/ic_edit.png")
    },
    on: {
      "click": _vm.editEdu
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4788b382","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/basic/components/basic/education/eduList/index.vue
// module id = 347
// module chunks = 0